import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "type", "gutter", "itemsPerRow", "nowrap", "totalCols", "debug", "ignoreKeyboardDebug", "className", "htmlProps"];
import { Children, cloneElement, isValidElement, useMemo } from 'react';
import cn from 'classnames';
import useDebug from "../useDebug";
import { DASHBOARD_GUTTER, DEFAULT_GUTTER } from "./constants";
import getMarginClass from "./helpers/getMarginClass";
import { jsx as _jsx } from "react/jsx-runtime";
var Row = function Row(_ref) {
  var childrenProp = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    gutterProp = _ref.gutter,
    itemsPerRow = _ref.itemsPerRow,
    nowrap = _ref.nowrap,
    totalColsProp = _ref.totalCols,
    debugProp = _ref.debug,
    ignoreKeyboardDebug = _ref.ignoreKeyboardDebug,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    htmlProps = _ref.htmlProps,
    rowProps = _objectWithoutProperties(_ref, _excluded);
  var debug = useDebug(debugProp, ignoreKeyboardDebug);
  var isDashboard = type === 'dashboard';
  var defaultGutter = isDashboard ? DASHBOARD_GUTTER : DEFAULT_GUTTER;
  var gutter = gutterProp || defaultGutter;
  var totalCols = totalColsProp || 12;
  var children = useMemo(function () {
    return Children.map(childrenProp, function (child) {
      if (! /*#__PURE__*/isValidElement(child)) {
        return null;
      }
      var childProps = {
        gutter: gutter,
        nowrap: nowrap,
        totalCols: totalCols
      };
      if (itemsPerRow) {
        if (typeof itemsPerRow === 'number' || typeof itemsPerRow === 'string') {
          childProps = _objectSpread(_objectSpread({}, childProps), {}, {
            xs: typeof itemsPerRow === 'number' ? 12 / itemsPerRow : itemsPerRow
          });
        } else {
          var xs = itemsPerRow.xs || 1;
          var sm = itemsPerRow.sm || xs;
          var md = itemsPerRow.md || sm;
          var lg = itemsPerRow.lg || md;
          childProps = _objectSpread(_objectSpread({}, childProps), {}, {
            xs: typeof xs === 'number' ? 12 / xs : xs
          });
          if (sm !== xs) {
            childProps = _objectSpread(_objectSpread({}, childProps), {}, {
              sm: typeof sm === 'number' ? 12 / sm : sm
            });
          }
          if (md !== sm) {
            childProps = _objectSpread(_objectSpread({}, childProps), {}, {
              md: typeof md === 'number' ? 12 / md : md
            });
          }
          if (lg !== md) {
            childProps = _objectSpread(_objectSpread({}, childProps), {}, {
              lg: typeof lg === 'number' ? 12 / lg : lg
            });
          }
        }
      }
      return /*#__PURE__*/cloneElement(child, _objectSpread(_objectSpread({}, childProps), child.props));
    });
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [childrenProp, type, gutter, itemsPerRow, nowrap, totalCols]);
  var gutterClasses = useMemo(function () {
    if (typeof gutter === 'number') {
      return getMarginClass(gutter, className, nowrap);
    }
    var xs = typeof gutter.xs === 'number' ? gutter.xs : 8;
    var sm = typeof gutter.sm === 'number' ? gutter.sm : xs;
    var md = typeof gutter.md === 'number' ? gutter.md : sm;
    var lg = typeof gutter.lg === 'number' ? gutter.lg : md;
    var classes = getMarginClass(xs, className, nowrap);
    if (sm !== xs) {
      classes = classes.concat(" ".concat(getMarginClass(sm, className, nowrap, 'sm')));
    }
    if (md !== sm) {
      classes = classes.concat(" ".concat(getMarginClass(md, className, nowrap, 'md')));
    }
    if (lg !== md) {
      classes = classes.concat(" ".concat(getMarginClass(lg, className, nowrap, 'lg')));
    }
    return classes;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gutter]);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({
    className: cn('flex', {
      'flex-wrap': !nowrap,
      'border border-solid border-secondary-light': debug
    }, gutterClasses, className)
  }, rowProps), htmlProps), {}, {
    children: children
  }));
};
export default Row;